import { create } from 'zustand';
import { Region } from 'react-native-maps';
import { LatLng, WebAndMobileRegion } from 'types/MapTypes';
import type { FiltersState } from 'components/map/ZoneFilterModal';

export type HidePolygons = {
  street: boolean;
  other: boolean;
};

const initialCoords: LatLng = {
  latitude: 0,
  longitude: 0,
};

const initialRegion: Region = {
  latitude: 60.192059,
  longitude: 24.945831,
  latitudeDelta: 0.015,
  longitudeDelta: 0.0121,
};

const initialFilters: FiltersState = {
  parkingAvailable: false,
  chargingAvailable: false,
  permits: false,
  prepaidsAvailable: false,
};

type MapState = {
  userLocation: LatLng | null;
  mapCoordinates: LatLng | LatLng[];
  optimizeMapContent: HidePolygons;
  regionCoordinates: WebAndMobileRegion;
  mapFilters: FiltersState;
  parkZonesFilterLoading: boolean;
  parkingTypesVisible: boolean;
  canStartParkingZoneUid: string;
};

type MapActions = {
  setUserLocation: (location: LatLng | null) => void;
  setMapCoordinates: (coordinates: LatLng | LatLng[]) => void;
  setOptimizeMapContent: (value: HidePolygons) => void;
  setRegionCoordinates: (region: WebAndMobileRegion) => void;
  setMapFilters: (filters: FiltersState) => void;
  setParkZonesFilterLoading: (loading: boolean) => void;
  setParkingTypesVisible: (visible: boolean) => void;
  setCanStartParkingZoneUid: (uid: string) => void;
};

export const useMapStore = create<MapState & MapActions>()((set) => ({
  userLocation: null,
  mapCoordinates: initialCoords,
  optimizeMapContent: { street: false, other: false },
  regionCoordinates: initialRegion,
  mapFilters: initialFilters,
  parkZonesFilterLoading: false,
  parkingTypesVisible: false,
  canStartParkingZoneUid: '',
  setUserLocation: (location) => set({ userLocation: location }),
  setMapCoordinates: (coordinates) => set({ mapCoordinates: coordinates }),
  setOptimizeMapContent: (value) => set({ optimizeMapContent: value }),
  setRegionCoordinates: (region) => set({ regionCoordinates: region }),
  setMapFilters: (filters) => set({ mapFilters: filters }),
  setParkZonesFilterLoading: (loading) =>
    set({ parkZonesFilterLoading: loading }),
  setParkingTypesVisible: (visible) => set({ parkingTypesVisible: visible }),
  setCanStartParkingZoneUid: (uid) => set({ canStartParkingZoneUid: uid }),
}));
